import Api from '../Api';

export const getTimeActionToCreate = jobchartId => async dispatch => {
  try {
    const { data } = await Api.get(`/timeactions/create/${jobchartId}`);

    return dispatch({
      type: 'FETCH_TIMEACTION',
      payload: data,
    });
  } catch (error) {
    console.error(error);
  }
};

export const getTimeActionToUpdate = jobchartId => async dispatch => {
  try {
    const { data } = await Api.get(`/timeactions/update/${jobchartId}`);

    return dispatch({
      type: 'FETCH_TIMEACTION',
      payload: data,
    });
  } catch (error) {
    console.error(error);
  }
};

export const getTimeAction = jobchartId => async dispatch => {
  try {
    const { data } = await Api.get(`/timeactions/${jobchartId}`);

    return dispatch({
      type: 'FETCH_TIMEACTION',
      payload: data,
    });
  } catch (error) {
    console.error(error);
  }
};

export const clearTimeAction = () => {
  return {
    type: 'CLEAR_TIMEACTION',
  };
};

export const getUserTimeActionTracking = query => async dispatch => {
  try {
    const { data } = await Api.get(`/timeactions/tracking/user`, query);

    return dispatch({
      type: 'FETCH_USER_TIMEACTION_TRACKING',
      payload: data,
    });
  } catch (error) {
    console.error(error);
  }
};

export const clearUserTimeActionTracking = () => {
  return {
    type: 'CLEAR_USER_TIMEACTION_TRACKING',
  };
};

export const getWeeklyPlans = id => async dispatch => {
  const { data } = await Api.get(`/timeactions/weeklyplan/${id}`);

  return dispatch({
    type: 'FETCH_WEEKLY_PLANS',
    payload: data,
  });
};

export const getUserTasks = (id, type) => async dispatch => {
  const { data } = await Api.get(`/timeactions/tasks/${id}/${type}`);

  return dispatch({
    type: 'FETCH_WEEKLY_PLANS',
    payload: data,
  });
};

export const clearWeeklyPlans = () => {
  return {
    type: 'CLEAR_WEEKLY_PLANS',
  };
};
